<template>
  <div class="renewals">
    <OrdersRenewalsSkeleton :is-loading="!isOrdersDataReady">
      <div v-if="!isEmpty" class="renewals__wrapper">
        <SmartLink route="prolongation" class="renewals__title-link flex items-center justify-between">
          <h2 class="renewals__title flex align-center justify-between">Моя пролонгація <ThickArrowIcon direction="right" /></h2>
        </SmartLink>
        <p class="orders-history__subtitle">Цього місяця буде {{ this.getExpirationText(getCurrentMonthValue('prolong'), getInsuranceProlongationForms) }}.</p>
        <RenewalsList :items="getOrdersProlongationList" />
      </div>
      <EmptyBlock v-else :title="getEmptyMessage.title" :description="getEmptyMessage.description" height="400px" />
    </OrdersRenewalsSkeleton>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import OrdersRenewalsSkeleton from '../orders-renewals-skeleton';
import RenewalsList from '../renewals-list';
import { insuranceProlongationForms } from '@/shared/config/expiration-forms';
import { expirationText } from '@/shared/lib/string';
import { EmptyBlock } from '@/shared/ui/empty-block';
import { ThickArrowIcon } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  created() {
    this.fetchOrdersList();
  },
  mixins: [ expirationText ],
  components: { ThickArrowIcon, RenewalsList, OrdersRenewalsSkeleton, EmptyBlock, SmartLink },
  computed: {
    ...mapGetters('ordersProlongationModule', [
      'isOrdersDataReady', 'isEmpty', 'getEmptyMessage', 'getOrdersProlongationList',
    ]),
    ...mapGetters('statisticSummaryModule', ['getCurrentMonthValue']),
    getInsuranceProlongationForms() {
      return insuranceProlongationForms.forms;
    },
  },
  methods: {
    ...mapActions('ordersProlongationModule', ['fetchOrdersList']),
  }
};
</script>

<style lang="scss" scoped>
.renewals {
  position: relative;
  border: 1px solid #E4E4E7;
  border-radius: 12px;
  padding: 24px 24px 48px;
  box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;
  margin-right: 16px;

  @media (max-width: 1050px) {
    margin-right: 0;
  }

  &__title {
    font-family: inherit;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  &__title-link {
    width: 100%;
  }
}
</style>
